import React from 'react'
import Layout from '../components/Layout/Layout'

const Pagenotfound = () => {
  return (
    <Layout>
    <h1 className='pnf'>Page Not Found </h1>
    </Layout>
  )
}

export default Pagenotfound